<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close transfer :loading="loading">
			<template #default>
				<div class="full competitivegoods_shop flex" style="padding: 10px;box-sizing: border-box;flex-direction: column;align-items: center;justify-content: center;">
					<div style="position: relative;width: 100%;margin-bottom: 20px;box-sizing: border-box;padding-left: 50px;padding-right: 50px;">
						<staff placeholder="接收人(不填发送给自己)" :collapseTags="false" :multiple="true" :value="staff" @modalsubmit="staffsubmit" />
					</div>
					<el-transfer filterable :filter-method="filterMethod" filter-placeholder=" " v-model="value"
						:data="data" :titles="['内置店铺', '导出店铺']" >
					</el-transfer>
				</div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style>
.competitivegoods_shop .el-transfer-panel{
	width: 300px !important;
	height: ;
}
</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import staff from '@_system/components/formcomponents/common/select/staff/select.vue'
	export default {
		mixins: [modalMixins],
		props: {
			shop: {
				default: () => {
					return {}
				}
			},
			grabcode: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				data: [],
				value: [],
				staff:[],
				filterMethod(query, item) {
					return item.label.indexOf(query) > -1;
				},
				loading: false,
				modal_model: false,
				modal_title: '选择店铺',
				modal_width: 900,
				modal_height: 500,
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			staffsubmit(e){
				//console.log(e)
				this.staff = e.data
			},
			modal_init() {
				this.data = this.generateData()
			},
			generateData() {
				let data = this.shop.map((item,index)=>{
					return {
						label : item.goodsshop + '【'+ item.type +'】',
						shop:item.goodsshop,
						key:index
					}
				})
				return data
			},
			submit() {
				let data = []
				this.value.forEach((item)=>{
					data.push(this.data[item].shop)
				})
				if(data.length == 0){
					this.$message.error('请选择店铺')
					return
				}
				this.loading = true
				this.$api.competitivegoodstask.exportdata({
					grabcode:this.grabcode,
					shopname:data,
					staff:this.staff
				}).then(()=>{
					this.modal_cancel()
					this.loading = false
					this.$message.success('操作成功')
				},()=>{
					this.loading = false
				})
				console.log(data,this.grabcode,this.staff)
				//this.modal_cancel()
			},
			modal_onhide() {
				this.value = []
			},
		},
		components: {
			staff
		}
	}
</script>